import React, { useMemo } from 'react';
import { randomStr } from '../Shared/random';
const useMemorizedRandomString = React.useId || (() => useMemo(() => randomStr(), []));
/**
 * Returns a function that generate a named DOM id for a component name as the prefix.
 *
 * Use random string for older versions of React, and use `useId` if available, for better SSR.
 */
export function useUniqueId(prefix) {
    const randomString = useMemorizedRandomString();
    return (suffix) => `${prefix}-${randomString}-${suffix}`;
}
